import React, { useMemo } from 'react';
import { useAtom } from 'jotai/index';
import moment from 'moment';
import classNames from 'classnames';
import styles from '../css/index.module.scss';
import {
  widgetDataAtom,
  widgetInputsAtom,
  widgetParamsAtom,
  widgetSuccessScreenTextAtom
} from '../../../atoms/widgetAtoms';
import useWidget from '../../../hooks/UseWidget';
import WT from '../constants/widgetTranslations';
import EmptyHeight from '../../../components/EmptyHeight';
import PartnersServices from '../../../services/PartnersServices';
import makeFirstUppercase from '../../../helpers/makeFirstUppercase';
import Telegram from '../../../assets/icons/telegram.svg';
import Whatsapp from '../../../assets/icons/whatsapp.svg';

function WidgetSuccessState() {
  const { t } = useWidget();
  const [widgetParams] = useAtom(widgetParamsAtom);
  const [widgetInputs] = useAtom(widgetInputsAtom);
  const [widgetData] = useAtom(widgetDataAtom);
  const [widgetSuccessScreenText] = useAtom(widgetSuccessScreenTextAtom);

  const onTelegramClick = () => {
    const text = t(WT.afterBook, {
      date: `${PartnersServices.convertSecondsToFormat(widgetInputs.slot)} ${moment(widgetParams.date).format('DD.MM.YYYY')}`,
      count: widgetParams.persons,
      name: widgetData.companyName,
      address: widgetData.address,
    });

    window.open(`https://t.me/share/url?url=${encodeURIComponent(text)}`, '_blank');
  };

  // console.log(navigator.userAgent);
  // console.log(navigator.platform);
  const onWhatsappClick = () => {
    const message = encodeURIComponent(t(WT.afterBook, {
      date: `${PartnersServices.convertSecondsToFormat(widgetInputs.slot)} ${moment(widgetParams.date).format('DD.MM.YYYY')}`,
      count: widgetParams.persons,
      name: widgetData.companyName,
      address: widgetData.address,
    }));
    window.open(`https://wa.me?text=${message}`, '_blank');
    // window.location = `tg://msg_url?text=${message}`;
  };

  return (
    <>
      <div className={styles.inputsState}>
        <p className={styles.inputsTitle}>{widgetSuccessScreenText || t(WT.successfullyCreated)}</p>
        <EmptyHeight height={24} />
        <p className={styles.text}>
          {makeFirstUppercase(moment(widgetParams.date).format('dddd, DD MMMM'))}
          {' '}
          {PartnersServices.convertSecondsToFormat(widgetInputs.slot)}
          ,
          {' '}
          {widgetParams.persons}
          {' '}
          {t(WT.person, widgetParams.persons)}
        </p>
        <EmptyHeight height={42} />
        <p className={styles.smallTitle}>{t(WT.share)}</p>
        <EmptyHeight height={18} />
        <div className={styles.shareRow}>
          <div className={classNames(styles.shareButton, styles.telegram)} onClick={onTelegramClick}>
            <img src={Telegram} alt="T" />
          </div>
          <div className={classNames(styles.shareButton, styles.whatsapp)} onClick={onWhatsappClick}>
            <img src={Whatsapp} alt="W" />
          </div>
        </div>
      </div>
    </>
  );
}

export default WidgetSuccessState;
